<template>
    <!-- 用户昵称 -->
    <span v-if="userInfo.nickname"
        class="f-user-name"
        :class="{'f-user-name-hover': isPc}"
        @click.stop="toUserInfo">
        {{userInfo.nickname}}
    </span>
</template>

<style lang="less">
    .f-user-name {
        &-hover:hover {
            cursor: pointer;
            text-decoration: underline;
        }
    }
</style>

<script>
import {mapState} from 'vuex';

export default {
    props: {
        userInfo: Object
    },
    computed: {
        ...mapState({
            isPc: state => state.common.isPc,
            webPages: state => state.common.webPages
        })
    },
    methods: {
        toUserInfo() {
            if (!this.isPc) {
                return;
            }
            const userNo = this.userInfo.userNo;
            window.open(`${this.webPages.userInfo}/${userNo}`);
        }
    }
};
</script>
